export default "__VITE_ASSET__MN7vF_k5__"